import { useQuery } from '@tanstack/react-query';
import { fetchPackageDropApi } from 'apis/package/packageApis';
import { IDropListProps } from 'utils/types/common';
/**
 * * 앱스토어 드롭다운 데이터
 */
function useStoreDropQuery(osType: string) {
  const { status, data, error, isFetching } = useQuery(
    ['storeDropList'],
    async () => await fetchPackageDropApi.store(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        let filterArr: IDropListProps[] = [];
        data.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: v.code_name,
          }),
        );
        if (osType === 'android') {
          filterArr = newArr.filter((v) => v.value !== 'apple');
        } else {
          filterArr = newArr.filter((v) => v.value === 'apple');
        }
        return filterArr;
      },
    },
  );
  return { status, data, error, isFetching };
}
export default useStoreDropQuery;
